module.exports = __webpack_public_path__ + "static/media/np_invoices_2064117_0E6EB8.aeefadd9.svg";